<template>
  <div class="modal-backdrop" @click="emit('close')">
    <section
      class="settings-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="settings-title"
      @click.stop
    >
      <div class="modal-header">
        <h3 id="settings-title">Settings</h3>
        <button class="close-button" type="button" aria-label="Close settings" @click="emit('close')">×</button>
      </div>

      <div class="field">
        <label for="default-coordinate-format">Default coordinate format</label>
        <select id="default-coordinate-format" ref="selectRef" v-model="draftFormat">
          <option v-for="option in COORDINATE_FORMAT_OPTIONS" :key="option.value" :value="option.value">
            {{ option.label }} — {{ option.sample }}
          </option>
        </select>
      </div>

      <p class="help">Controls default output display for editing mode and PDF Export.</p>
      <p v-if="error" class="error" role="alert">{{ error }}</p>

      <div class="actions">
        <button class="secondary" data-action="cancel" type="button" @click="emit('close')">Cancel</button>
        <button class="primary" data-action="save" type="button" @click="save">Save</button>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { COORDINATE_FORMAT_OPTIONS } from "@/utils/userPreferences"

const props = defineProps({
  coordinateFormat: { type: String, default: "ddm" },
  error: { type: String, default: "" },
})
const emit = defineEmits(["save", "close"])
const draftFormat = ref(props.coordinateFormat)
const selectRef = ref(null)

function save() {
  emit("save", { coordinateFormat: draftFormat.value })
}

onMounted(() => selectRef.value?.focus())
</script>

<style scoped>
.modal-backdrop { position: fixed; inset: 0; z-index: 1200; display: grid; place-items: center; padding: var(--space-4); background: var(--color-overlay); }
.settings-modal { box-sizing: border-box; width: min(720px, 100%); min-width: 0; padding: var(--space-5); border: 1px solid var(--color-border); border-radius: var(--radius-lg); background: var(--color-bg-raised); color: var(--color-text); box-shadow: var(--shadow-lg); }
.modal-header, .actions { display: flex; align-items: center; justify-content: space-between; gap: var(--space-3); }
.modal-header { margin-bottom: var(--space-4); }
h3 { margin: 0; }
.close-button { border: 0; background: transparent; color: var(--color-text-muted); font-size: 1.5rem; line-height: 1; cursor: pointer; }
.field { display: grid; gap: var(--space-2); }
label { color: var(--color-text-muted); font-size: var(--fs-sm); font-weight: 600; }
select { box-sizing: border-box; width: 100%; min-width: 0; max-width: 100%; padding: var(--space-3); border: 1px solid var(--color-border); border-radius: var(--radius-md); background: var(--color-bg); color: var(--color-text); font: inherit; text-overflow: ellipsis; }
option { max-width: 100%; }
.help, .error { margin: var(--space-3) 0 0; font-size: var(--fs-sm); }
.help { color: var(--color-text-muted); }
.error { color: var(--color-danger); }
.actions { justify-content: flex-end; margin-top: var(--space-5); }
.actions button { padding: var(--space-2) var(--space-4); border-radius: var(--radius-md); cursor: pointer; font: inherit; }
.secondary { border: 1px solid var(--color-border); background: var(--color-bg); color: var(--color-text); }
.primary { border: 1px solid var(--color-accent); background: var(--color-accent); color: white; }
</style>
